(function () {
  var cfg = window.NGW || {};

  /* ---------- GA4 ---------- */
  function isProd() {
    return (cfg.prodHosts || []).indexOf(location.hostname.toLowerCase()) !== -1;
  }
  function envParams() {
    return isProd() ? {} : { debug_mode: true, traffic_type: "internal" };
  }
  function initGA() {
    if (!cfg.gaId) return false;
    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };
    if (!window.__ngwGa) {
      window.gtag("js", new Date());
      window.gtag("config", cfg.gaId, envParams());
      var s = document.createElement("script");
      s.async = true;
      s.src = "https://www.googletagmanager.com/gtag/js?id=" + encodeURIComponent(cfg.gaId);
      document.head.appendChild(s);
      window.__ngwGa = true;
    }
    return true;
  }
  function track(name, params) {
    if (!initGA()) return;
    var p = Object.assign({}, params || {}, envParams());
    window.gtag("event", name, p);
  }
  initGA();

  document.addEventListener("click", function (e) {
    var line = e.target.closest("[data-line-location]");
    if (line) track("line_click", { link_location: line.getAttribute("data-line-location") });
    var ig = e.target.closest("[data-ig-location]");
    if (ig) track("instagram_click", { link_location: ig.getAttribute("data-ig-location") });
  }, true);

  if (window.NGW_LEAD_SENT) track("generate_lead", { form_name: "enterprise_inquiry" });

  /* ---------- Product gallery ---------- */
  function selectGalleryMedia(gallery, mediaId) {
    if (!gallery || !mediaId) return;
    var mainImage = gallery.querySelector("[data-product-gallery-main]");
    var selectedThumbnail = null;
    var thumbnails = gallery.querySelectorAll("[data-product-gallery-thumbnail]");

    thumbnails.forEach(function (thumbnail) {
      if (thumbnail.getAttribute("data-media-id") === String(mediaId)) selectedThumbnail = thumbnail;
    });

    if (!mainImage || !selectedThumbnail) return;
    thumbnails.forEach(function (thumbnail) {
      thumbnail.setAttribute("aria-current", thumbnail === selectedThumbnail ? "true" : "false");
    });
    mainImage.removeAttribute("srcset");
    mainImage.src = selectedThumbnail.getAttribute("data-image-url");
    mainImage.alt = selectedThumbnail.getAttribute("data-image-alt") || "";
    mainImage.setAttribute("width", selectedThumbnail.getAttribute("data-image-width"));
    mainImage.setAttribute("height", selectedThumbnail.getAttribute("data-image-height"));
    mainImage.setAttribute("data-media-id", selectedThumbnail.getAttribute("data-media-id"));
  }

  document.querySelectorAll("[data-product-gallery]").forEach(function (gallery) {
    gallery.addEventListener("click", function (event) {
      var thumbnail = event.target.closest("[data-product-gallery-thumbnail]");
      if (!thumbnail || !gallery.contains(thumbnail)) return;
      selectGalleryMedia(gallery, thumbnail.getAttribute("data-media-id"));
    });
  });

  /* ---------- Retail product form ---------- */
  document.querySelectorAll("[data-retail-product-form]").forEach(function (form) {
    var productMain = form.closest(".product-main");
    var select = form.querySelector("[data-retail-variant-select]");
    var price = productMain ? productMain.querySelector("[data-retail-price]") : null;
    var addButton = form.querySelector("[data-retail-add-button]");
    var gallery = productMain ? productMain.querySelector("[data-product-gallery]") : null;
    if (!select) return;

    select.addEventListener("change", function () {
      var option = select.options[select.selectedIndex];
      var available = option && option.getAttribute("data-available") === "true";
      if (price && option) price.textContent = option.getAttribute("data-price") || price.textContent;
      if (gallery && option) selectGalleryMedia(gallery, option.getAttribute("data-media-id"));
      if (addButton) {
        addButton.disabled = !available;
        addButton.textContent = available ? "加入購物車" : "暫時售罄";
      }
    });
  });

  /* ---------- Mobile menu ---------- */
  var toggle = document.querySelector(".menu-toggle");
  var nav = document.getElementById("site-navigation");
  function setMenu(open) {
    if (!toggle || !nav) return;
    nav.classList.toggle("is-open", open);
    toggle.setAttribute("aria-expanded", open ? "true" : "false");
    toggle.setAttribute("aria-label", open ? "關閉選單" : "開啟選單");
  }
  if (toggle && nav) {
    toggle.addEventListener("click", function () { setMenu(!nav.classList.contains("is-open")); });
    nav.addEventListener("click", function (e) { if (e.target.closest("a")) setMenu(false); });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") setMenu(false); });
  }

  /* ---------- Nutritionist video ---------- */
  document.querySelectorAll(".nutrition-video-frame").forEach(function (frame) {
    var video = frame.querySelector("video");
    var btn = frame.querySelector("button.nutrition-video-play");
    if (!video) return;
    var tracked = false;
    if (btn) btn.addEventListener("click", function () { var p = video.play(); if (p) p.catch(function () {}); });
    video.addEventListener("play", function () {
      if (btn) btn.hidden = true;
      if (!tracked) { tracked = true; track("video_play", { video_id: "ig-1" }); }
    });
  });

  /* ---------- Inquiry form: scroll back to result ---------- */
  if (location.hash === "#ngw-inquiry-form" || location.search.indexOf("contact_posted=true") !== -1) {
    var f = document.getElementById("inquiry");
    if (f) f.scrollIntoView();
  }
})();
